/* KARMA - varians-orzo

   A SZABALY: ha a vevo altal valasztott meret az UJONNAN valasztott szinben nincs,
   akkor a temanak KI KELL VENNIE a meret-kijelolest - nem szabad csendben masikra
   valtani.

   MIERT: a Dawn magatol a legkozelebbi LETEZO varianst valasztja (Dark Brown/8.5 ->
   Luggage/9), a gomb pedig aktiv marad. A vevo azt hiszi, a sajat merete van a
   kosarban, kozben eggyel nagyobb. Elfogyott mereteket rejtjuk, tehat a csere nem
   is latszik.

   A ZAROLT ALLAPOT harom dolgot csinal egyszerre, mert barmelyik onmagaban kevés:
     1. egyetlen meret sincs bejelolve,
     2. a Kosarba gomb tiltva, felirata "Válassz méretet",
     3. a rejtett varians-ID input letiltva - igy egy eroltetett submit (Enter a
        mennyiseg-mezoben, kettos katt) sem tud rossz varianst kosarba tenni.

   A kepvalasztashoz semmi koze: azt a galeria kezeli, es CSAK szinre reagal.

   A meret ALAPBOL NINCS kijelolve, a szin marad. Amig a vevo nem kattint meretre,
   a lap a zarolt allapotban all (szinvaltas utan is). Kivetel: ha a lap ?variant=
   parameterrel nyilik (hirdetes, Shopping, kosarbol vissza), az mar konkret
   valasztas. Ha a meretnek egyetlen erteke van, nincs mit valasztani. */
(function () {
  var EN = /^en/i.test(document.documentElement.lang || '');
  var VART_FELIRAT = EN ? 'Select a size' : 'Válassz méretet';
  /* A vevo tudatosan valasztott-e mar meretet ezen a lapon. */
  var meretValasztva = /[?&]variant=\d/.test(location.search);

  function meretDoboz() {
    var dobozok = document.querySelectorAll('variant-selects fieldset, .product-form__input');
    for (var i = 0; i < dobozok.length; i++) {
      var lg = dobozok[i].querySelector('legend, .form__label');
      if (lg && /m[eé]ret|size/i.test(lg.textContent)) return dobozok[i];
    }
    return null;
  }
  function meretInputok(doboz) {
    return Array.prototype.slice.call(doboz.querySelectorAll('input[type=radio]'));
  }
  /* "nem valaszthato": a Dawn disabled-osztalya A hiteles jel (value.available),
     a rejtes csak ennek a kovetkezmenye - ezert az osztalyt nezzuk, nem a lathatosagot.
     (A Browser-panelen / hatterbe tett lapon az offsetParent amugy is megbizhatatlan.) */
  function tiltott(input) {
    return !input || input.disabled || input.classList.contains('disabled');
  }

  /* Az utoljara ERVENYESEN kivalasztott meret. Kezdoertek a betolteskori kijeloles:
     azt is "a vevo meretenek" tekintjuk, kulonben az elso szinvaltas eszrevetlenul
     athangolna. */
  var emlekMeret = null;
  var zarolva = false;

  function jegyez() {
    var doboz = meretDoboz();
    if (!doboz) return;
    var k = meretInputok(doboz).filter(function (i) { return i.checked; })[0];
    if (k && !tiltott(k)) emlekMeret = k.value;
  }

  /* --- a zarolt allapot ki/be kapcsolasa. Mindketto IDEMPOTENS: csak akkor ir a
     DOM-ba, ha tenylegesen valtozik valami - kulonben a MutationObserver onmagat
     hivna korbe-korbe. --- */
  function gomb() { return document.querySelector('.product-form__buttons button[name="add"]'); }
  function variansMezo() { return document.querySelector('form[action*="/cart/add"] input[name="id"]'); }

  function zarol(doboz, hianyzoMeret, csendes) {
    var inputok = meretInputok(doboz);
    inputok.forEach(function (i) { if (i.checked) i.checked = false; });

    var g = gomb();
    if (g) {
      var cel = g.querySelector('span') || g;
      /* A "data-karma-tiltva" jelzi, hogy a gomb allapota A MIENK. A Dawn
         ujrarajzolaskor uj gombelemet tesz be, azon nincs rajta a jelzo - igy
         sosem allitunk vissza olyat, amit nem mi allitottunk el. */
      if (!g.hasAttribute('data-karma-tiltva')) {
        g.setAttribute('data-karma-tiltva', g.disabled ? '1' : '0');
        g.setAttribute('data-karma-felirat', cel.textContent);
      }
      if (!g.disabled) g.disabled = true;
      if (cel.textContent.trim() !== VART_FELIRAT) cel.textContent = VART_FELIRAT;
    }
    var v = variansMezo();
    if (v && !v.disabled) v.disabled = true;

    /* Indoklas a meretsor ala: enelkul a vevo csak annyit lat, hogy elveszett a
       kijelolese, es nem erti, miert. */
    var jel = doboz.querySelector('[data-karma-meretjel]');
    /* Kezdo allapotban nincs indoklo sor: a gomb felirata ugyanezt mondja. */
    if (csendes) { if (jel) jel.remove(); zarolva = true; return; }
    if (!jel) {
      jel = document.createElement('p');
      jel.setAttribute('data-karma-meretjel', '');
      jel.className = 'karma-meretjel';
      doboz.appendChild(jel);
    }
    var uzenet = hianyzoMeret
      ? (EN ? 'Size ' + hianyzoMeret + ' is not available in this colour. Please choose another size.'
            : 'Ebben a színben nincs ' + hianyzoMeret + '-es méret. Válassz az elérhetők közül.')
      : (EN ? 'Select a size.' : 'Válassz méretet.');
    if (jel.textContent !== uzenet) jel.textContent = uzenet;
    zarolva = true;
  }

  function felold(doboz) {
    var g = gomb();
    /* CSAK a sajat nyomainkat takaritjuk. Ha nincs rajta a jelzo, akkor a gomb
       allapota a Dawn-e (pl. valoban elfogyott varians) - ahhoz nem nyulunk. */
    if (g && g.hasAttribute('data-karma-tiltva')) {
      (g.querySelector('span') || g).textContent = g.getAttribute('data-karma-felirat');
      g.disabled = g.getAttribute('data-karma-tiltva') === '1';
      g.removeAttribute('data-karma-tiltva');
      g.removeAttribute('data-karma-felirat');
    }
    var v = variansMezo();
    if (v && v.disabled) v.disabled = false;
    if (doboz) {
      var jel = doboz.querySelector('[data-karma-meretjel]');
      if (jel) jel.remove();
    }
    zarolva = false;
  }

  function ellenoriz() {
    var doboz = meretDoboz();
    if (!doboz) return;
    var inputok = meretInputok(doboz);
    if (!inputok.length) return;

    var vanElerheto = inputok.some(function (i) { return !tiltott(i); });
    if (!vanElerheto) { felold(doboz); return; }   /* teljesen elfogyott szin: a Dawn sajat "Elfogyott" allapota all */
    if (inputok.length === 1) meretValasztva = true;

    /* Amíg a vevő nem valasztott meretet, a kijeloles ures marad. */
    if (!meretValasztva) { zarol(doboz, null, true); return; }

    var kivalasztott = inputok.filter(function (i) { return i.checked; })[0];

    /* A vevo merete letezik es vehet o ebben a szinben -> minden rendben. */
    if (kivalasztott && !tiltott(kivalasztott)) {
      emlekMeret = kivalasztott.value;
      if (zarolva) felold(doboz);
      return;
    }
    /* Nincs ervenyes kijeloles: a Dawn vagy tiltott meretet hagyott bejelolve, vagy
       (a mi zarolasunk utan) semmit. Zarolunk, es megmondjuk, mi hianyzik. */
    zarol(doboz, emlekMeret);
  }

  /* A vevo sajat kattintasa a meretre: ez tudatos valasztas -> feloldas. A Dawn
     ujrarajzolja a gombot es a varians-ID-t, a felold() csak a mi nyomainkat takaritja. */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('variant-selects, .product-form__input')) return;
    var doboz = meretDoboz();
    if (doboz && doboz.contains(t)) {
      if (!tiltott(t)) { meretValasztva = true; emlekMeret = t.value; felold(doboz); }
    }
    setTimeout(ellenoriz, 60);
  });

  /* A Dawn a szekcio-ujrarajzolassal cserel markupot - fix idozitessel nem lehet
     eltalalni (merten 350 ms utan is a regi DOM allt). Ezert a valtozast figyeljuk. */
  var utem = null;
  var figyelo = new MutationObserver(function () {
    clearTimeout(utem);
    utem = setTimeout(ellenoriz, 40);
  });
  function figyelniKezd() {
    var cel = document.querySelector('variant-selects');
    var urlap = document.querySelector('form[action*="/cart/add"]');
    if (cel) figyelo.observe(cel, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'checked'] });
    if (urlap) figyelo.observe(urlap, { childList: true, subtree: true });
  }

  if (meretValasztva) jegyez();
  figyelniKezd();
  /* Azonnal is: kulonben a betolteskor par szaz ms-ig latszana az elore kijelolt meret. */
  ellenoriz();
  setTimeout(ellenoriz, 400);
})();
